document.addEventListener('DOMContentLoaded', function () {
    // Home Page Sidebar
    function handleHomepageSidebar() {
        let settings = {
            contentClass: '.tab-content',
            navigationId: '#sub-nav'
        };
        $(settings.contentClass).not(':first').hide();
        $(settings.navigationId).find('li:first').addClass('current-tab');
        $(settings.navigationId).find('a').click(function (e) {
            $(".sidebar-home, #sidebar-sticky").unstick();
            let contentToShow = $(this).attr('href');
            contentToShow = $(contentToShow);
            e.preventDefault();
            $(settings.navigationId).find('li').removeClass('current-tab');
            $(this).parent('li').addClass('current-tab');
            $(settings.contentClass).hide();
            contentToShow.show();
            handleSticky();
        });
    }
    handleHomepageSidebar();

    // Sticky Sidebar
    function handleSticky() {
        const currentWidth = $(window).width();
        if (currentWidth >= 1200) {
            const defaultBottomSpace = $(".footer").outerHeight();
            const homeBottomSpace = $("#home-cta-bottom").outerHeight() + $(".footer").outerHeight() + 70;
            const interiorTwoBottomSpace = $("#sub-cta-bottom").outerHeight() + $(".footer").outerHeight() + $(".section-6").outerHeight() + $(".accordion-sub-page").outerHeight() + 70;
            const interiorOneBottomSpace = $("#interior-cta-bottom").outerHeight() + $(".footer").outerHeight() + $(".interior-one.section-5").outerHeight() + $(".interior-one.section-4").outerHeight() + $(".interior-one.section-3").outerHeight() + $(".interior-one.section-2").outerHeight();
            $(".sticky.sticky-default").sticky({
                topSpacing: 105,
                bottomSpacing: defaultBottomSpace
            });
            $(".sticky.sticky-home").sticky({
                topSpacing: 105,
                bottomSpacing: homeBottomSpace
            });
            $(".sticky.sticky-interior-two").sticky({
                topSpacing: 105,
                bottomSpacing: interiorTwoBottomSpace
            });
            $(".sticky.sticky-interior-one").sticky({
                topSpacing: 105,
                bottomSpacing: interiorOneBottomSpace
            });
        } else {
            $(".sticky").unstick();
        }
    }

    $(window).resize(function () {
        handleSticky();
    });
    handleSticky();
});